import { getPreviousDate, stringToDate } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { evolutionOffersCurrentPeriod, priceDiscountEndDate } from "../../@signals"


export const rangeDatesPricingDiscountOffersEvolution = [{
    label: 'Yesterday',
    value: () => { return [getPreviousDate({ days: 1 }, priceDiscountEndDate.value), getPreviousDate({ days: 1 }, priceDiscountEndDate.value)] },
    placement: 'left',
    onFocus: () => evolutionOffersCurrentPeriod.value = DATE_PERIODS.YESTERDAY
}, {
    label: 'Last 7 Days',
    value: () => { return [getPreviousDate({ days: 6 }, priceDiscountEndDate.value), stringToDate(priceDiscountEndDate.value)] },
    placement: 'left',
    onFocus: () => evolutionOffersCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS
}, {
    label: 'Last 30 Days',
    value: () => { return [getPreviousDate({ days: 29 }, priceDiscountEndDate.value), stringToDate(priceDiscountEndDate.value)] },
    placement: 'left',
    onFocus: () => evolutionOffersCurrentPeriod.value = DATE_PERIODS.LAST_30_DAYS
}, {
    label: 'Last Month',
    value: () => {
        return [
            getPreviousDate({ months: 1 }, new Date(stringToDate(priceDiscountEndDate.value).setDate(1))),
            getPreviousDate({ days: 1 },  new Date(stringToDate(priceDiscountEndDate.value).setDate(1)))
        ]
    },
    placement: 'left',
    onFocus: () => evolutionOffersCurrentPeriod.value = DATE_PERIODS.LAST_MONTH
}]